import { Component } from '@angular/core';

@Component({
    selector: 'kh-divider',
    styleUrls: ['./divider.component.less'],
    templateUrl: './divider.component.html',
    standalone: false
})
export class DividerComponent {

}
